/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ApplicationControllerService } from './services/application-controller.service';
import { AppointmentControllerService } from './services/appointment-controller.service';
import { DoctorControllerService } from './services/doctor-controller.service';
import { MessageTemplateManagementControllerService } from './services/message-template-management-controller.service';
import { PharmacyControllerService } from './services/pharmacy-controller.service';
import { PingControllerService } from './services/ping-controller.service';
import { ProviderDoctorControllerService } from './services/provider-doctor-controller.service';
import { ProviderControllerService } from './services/provider-controller.service';
import { UserControllerService } from './services/user-controller.service';
import { WorkflowManagementControllerService } from './services/workflow-management-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApplicationControllerService,
    AppointmentControllerService,
    DoctorControllerService,
    MessageTemplateManagementControllerService,
    PharmacyControllerService,
    PingControllerService,
    ProviderDoctorControllerService,
    ProviderControllerService,
    UserControllerService,
    WorkflowManagementControllerService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
